import 'css-chunk:../../src/components/bar-button/index.module.scss';export default {
  "pro_indicator": "_pro_indicator_1q494_1"
};